interface LoadingDisplayProps {
  message?: string;
  subtitle?: string;
}

export function LoadingDisplay({
  message = 'Loading...',
  subtitle,
}: LoadingDisplayProps) {
  return (
    <div className="flex h-full items-center justify-center bg-surface">
      <div className="loading-placeholder text-center">
        <div className="mb-3 inline-block h-6 w-6 animate-spin rounded-full border-2 border-line-strong border-t-brand-500" />
        <p className="text-sm text-ink-2">{message}</p>
        {subtitle && <p className="mt-1 text-xs text-muted">{subtitle}</p>}
      </div>
    </div>
  );
}
